module.exports = __webpack_public_path__ + "static/img/联系.3307ccd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/common/联系.jpg
// module id = Tm+2
// module chunks = 1